import React from 'react'
import './index.scss'

interface Props {
  firText: string
  firFun: any
  firDisabled?: boolean
  secText: string
  secFun: any
  secDisabled?: boolean
}
const FButton: React.FC<Props> = ({ firText, firFun, secText, secFun, firDisabled = false, secDisabled = false }) => {
  return (
    <div className='footer-btn-group'>
      <div
        className={`btn btn-create ${firDisabled ? 'btn-disabled' : ''}`}
        onClick={() => {
          !firDisabled && firFun()
        }}
      >
        <span className='btn-text'>{firText}</span>
      </div>
      <div
        className={`btn btn-toggle ${secDisabled ? 'btn-disabled' : ''}`}
        onClick={() => {
          !secDisabled && secFun()
        }}
      >
        <span className='btn-text'>{secText}</span>
      </div>
    </div>
  )
}

export default FButton
